import { IActiveNotificationSetAction } from './types';
import { AT_ACTIVE_NOTIFICATION_UPDATE } from './constants';

export const activeNotificationSetAction = (
    activeNotification: number
): IActiveNotificationSetAction => ({
    type: AT_ACTIVE_NOTIFICATION_UPDATE,
    activeNotification
});
